import React, { FC } from 'react';
import * as Styled from './ListView.styles';
import { ListViewGroup } from './ListViewGroup';
import { sortedCollectionsType } from '../../types';

interface ListViewProps {
  sortedCollections: sortedCollectionsType[];
  selectedCategoryId: string | null;
  onSeeAllClick: (categoryId: string | null) => void;
}

export const ListView: FC<ListViewProps> = ({
  sortedCollections,
  onSeeAllClick,
  selectedCategoryId,
}) => {
  console.log();
  return (
    <Styled.Container>
      {sortedCollections.map((sortedCollection) => (
        <ListViewGroup
          key={sortedCollection.category_id}
          collection={sortedCollection}
          onSeeAllClick={onSeeAllClick}
          selected={sortedCollection.category_id === selectedCategoryId}
        />
      ))}
    </Styled.Container>
  );
};
